import React, { useState, useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { ListBox } from 'primereact/listbox';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import SEARCH_CRITERIA from '../common/search-criteria';
import { useRootStore } from '../hooks/use-stores';
import localized from '../common/localization';

const SiderFilters = observer( (props) => {
	const { urlParamsMap, searchParams } = props;
	const [selectedFilterClass, setSelectedFilterClass] = useState(null);
	const [selectedCountries, countriesOptions, setCountriesValue] = props.countriesState;
	const [priceMin, setPriceMin] = useState(0);
	const [priceMax, setPriceMax] = useState('');
	const [textSearch, setTextSearch] = useState('');
	const [checked, setChecked] = useState(false);
	const rootStore = useRootStore();
	const navigateToFilteredUrlTimeout = useRef();

	const selectedCountriesTxt = useMemo( () => {
		if (!selectedCountries) {
			return null;
		}
		return selectedCountries.map(i => i.name).join(', ');
	}, [selectedCountries]);

	const priceFilterTxt = useMemo( () => {
		return [
			priceMin > 0 ? `>= ${priceMin}€` : ''
			,priceMax > 0 ? `<= ${priceMax}€` : ''
		].filter(i => i).join(', ');
	}, [priceMin, priceMax]);


	const filterClassOptions = useMemo( () => {
		console.log('recalculating filter class options');
		return Object.keys(SEARCH_CRITERIA).map(ckey => {
			let o = SEARCH_CRITERIA[ckey];
			return { code: ckey, name: localized[o.label] || o.label, localizedKeys: o.localizedKeys }
		}).filter(i => {
			return true;
			/*if (!urlParamsMap.has('class')) {
				return true;
				}
				return i.code == urlParamsMap.get('class');*/
		});
	}, [urlParamsMap, rootStore.appLang]);

	useEffect( () => {
		let v = urlParamsMap.has('class') ? urlParamsMap.get('class') : null;
		let opt = filterClassOptions.find(o => {
			if (o.code == v) {
				return true;
			}
			if (o.localizedKeys && Object.keys(o.localizedKeys).find(lang => o.localizedKeys[lang] == v)) {
				return true;
			}
			return false;
		});
		setSelectedFilterClass(opt || null);
	}, [urlParamsMap, filterClassOptions]);

	useEffect( () => {
		let qFilter = props.searchFilters.find(f => f.type == 'q');
		setTextSearch(qFilter ? qFilter.text : '');
		let priceFilter = props.searchFilters.find(f => f.type == 'price');
		setPriceMin(priceFilter && priceFilter.priceFrom > 0 ? priceFilter.priceFrom : '');
		setPriceMax(priceFilter && priceFilter.priceTo > 0 ? priceFilter.priceTo : '');
	}, [props.searchFilters]);

	/*
	const availableCatsSubcats = useMemo( () => {
		let cats = new Set()
			,subcats = new Set()
			,catsSubcats = new Set();
		props.filteredProducts.forEach( p => {
			if (p.origCategory) {
				cats.add(p.origCategory);
			}
			if (p.origSubcategory) {
				subcats.add(p.origSubcategory);
			}
			catsSubcats.add(`${p.origCategory} - ${p.origSubcategory}`);
		});
		console.log([cats, subcats, catsSubcats]);
		return [cats, subcats, catsSubcats];
	}, [props.filteredProducts]);
	*/

	const setFilterClassValue = (e) => {
		//console.log(e.value);
		setSelectedFilterClass(e.value);
		if (e.value) {
			let o = e.value;
			let code = (rootStore.appLang == 'it') ? 
				o.code
				: (o.localizedKeys[rootStore.appLang] || o.code)
			;
			urlParamsMap.set('class', code);
		}
		else {
			urlParamsMap.delete('class');
		}
		props.navigateToUrlByParams(urlParamsMap, searchParams);
	}

	const setTextSearchValue = (e) => {
		setTextSearch(e.target.value);
		searchParams.set('q', e.target.value);
		clearTimeout(navigateToFilteredUrlTimeout.current);
		navigateToFilteredUrlTimeout.current = setTimeout( () => {
			props.navigateToUrlByParams(urlParamsMap, searchParams);
		}, 2800);
	}

	const onKeyPress = (e) => {
                if (e.key === 'Enter') {
			clearTimeout(navigateToFilteredUrlTimeout.current);
			searchParams.set('q', textSearch);
			props.navigateToUrlByParams(urlParamsMap, searchParams);
                }
        }

	const setPriceSearchParamsByArrayAndNavigateToFilter = (values) => {
		let priceFilter = values.map(i => i > 0 ? i : '');
		let hasPriceFilter = priceFilter.filter(i => i > 0);
		if (hasPriceFilter) {
			searchParams.set('price', priceFilter.join(','));
		}
		else {
			searchParams.delete('price');
		}
		clearTimeout(navigateToFilteredUrlTimeout.current);
		navigateToFilteredUrlTimeout.current = setTimeout( () => {
			props.navigateToUrlByParams(urlParamsMap, searchParams);
		}, 2000);
	}

	const setPriceMinValue = (e) => {
		//console.log(e.value);
		setPriceMin(e.value);
		let values = [+e.value, +priceMax];
		setPriceSearchParamsByArrayAndNavigateToFilter(values);
	}
	const setPriceMaxValue = (e) => {
		//console.log(e.value);
		setPriceMax(e.value);
		let values = [+priceMin, +e.value];
		setPriceSearchParamsByArrayAndNavigateToFilter(values);
	}

	const countryTemplate = (option) => {
		return (
		    <React.Fragment>
		    <div className="fake-checkbox flex">            
			<div className="p-checkbox p-component p-checkbox-checked mr-2">
			    <div className="p-checkbox-box p-highlight">
				<span className="p-checkbox-icon p-c pi pi-check"></span>
			    </div>
			</div>            
			<div className="country-item">
			    <div>{option.name}</div>
			</div>
		    </div>
		    </React.Fragment>
		);
	}


    return (
	<Sidebar maskClassName="filters-sidebar" blockScroll visible={props.sidebarOpen} position="right" onHide={props.onSidebarClose}>
	    <div className="sidebar-content-container"> 
		<div className="sidebar-content-content"> 
		    <Accordion activeIndex={null}>
				<AccordionTab header={<div>
					{localized.WineType} {selectedFilterClass && <small>({selectedFilterClass.name})</small>}
				</div>
				}>
				    <ListBox className="false-radio" value={selectedFilterClass} options={filterClassOptions} onChange={setFilterClassValue} filter optionLabel="name" itemTemplate={countryTemplate} style={{}} listStyle={{ maxHeight: '250px' }}
				    />

				</AccordionTab>
				<AccordionTab header={<div>
					{localized.Countries} {selectedCountriesTxt && <small>({selectedCountriesTxt})</small>}
				</div>
				}>
				    <ListBox className="false-radio" value={selectedCountries} options={countriesOptions} onChange={setCountriesValue} multiple filter optionLabel="name" itemTemplate={countryTemplate} style={{ }} listStyle={{ maxHeight: '250px' }}
				    />
				</AccordionTab>				
				<AccordionTab header={<div>
					{localized.Price} {priceFilterTxt && <small>({priceFilterTxt})</small>}
				</div>}>
				    <div className="p-inputgroup">
					<span className="p-inputgroup-addon">min</span>
					<InputNumber value={priceMin} min={0} onChange={setPriceMinValue} placeholder="0 €" mode="currency" minFractionDigits="0" currency="EUR" locale="it-IT"/>
					<span className="p-inputgroup-addon">max</span>
					<InputNumber value={priceMax} onChange={setPriceMaxValue} placeholder="€" mode="currency" minFractionDigits="0" currency="EUR" locale="it-IT" />
				     </div>
				</AccordionTab>	
				<AccordionTab header={<div>
						{localized.TextSearch} {textSearch && <small>({textSearch})</small>}
					</div>}>
				    <span className="p-input-icon-left">
					    <i className="pi pi-search" />
					    <InputText value={textSearch} onKeyPress={onKeyPress} onChange={setTextSearchValue} placeholder="Search" />
				    </span>
				</AccordionTab>
		    </Accordion>
		</div>
		<div className="sidebar-content-footer"> 
			<Button onClick={props.clearFilters} label={localized.ResetFilters} className="p-button-rounded  p-button-outlined "   />
			<Button onClick={props.onSidebarClose} label={`${localized.Show} ${props.filteredProducts.length}`} className="p-button-rounded "  icon="pi pi-eye"  />
		</div>                   
	      
	    </div>
	    
	</Sidebar>

               
         
    )
} );

export default SiderFilters;
